import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="bg-gradient-to-r from-blue-400 to-blue-200">
            <div className="w-9/12 m-auto py-8 xm:py-16 min-h-screen flex items-center justify-center">
                <div className="bg-white shadow overflow-hidden xm:rounded-lg pb-8">
                    <div className="border-t border-gray-200 text-center pt-8">
                        <h1 className="text-5xl xm:text-9xl font-bold text-secondary">404</h1>
                        <h1 className="text-2xl xm:text-6xl font-medium py-4 xm:py-8">oops! Page not found</h1>
                        <p className="text-lg xm:text-2xl pb-4 xm:pb-8 px-4 xm:px-12 font-medium">Oops! The page you are looking for does not exist. It might have been moved or deleted.</p>
                        <button className="bg-gradient-to-r from-blue-400 to-blue-300 hover:from-custom-blue hover:to-secondary text-white font-semibold px-6 py-2 rounded-md mr-6"
                            onClick={() => navigate("/", { replace: true })}>
                            HOME
                        </button>
                        <button className="bg-gradient-to-r from-red-400 to-red-500 hover:from-red-500 hover:to-red-500 text-white font-semibold px-6 py-2 rounded-md"
                            onClick={() => navigate("/contact-us", { replace: true })}>
                            Contact Us
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageNotFound;